// ======= Cookie message =======

jQuery('#cookie-message-close').click(function(){
	jQuery('#cookie-message').hide();
	Cookies.set('cookie-message-bar', true, { expires: 120 }); // Cookie expiration (days)
});

if (!Cookies.get("cookie-message-bar")){
	jQuery('#cookie-message').show();
}